import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1A620C83-4D7F-4175-998B-E3460C77510D
 * name bucket-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bucket-outline.svg
 * tags
 */
export const BucketOutlineIcon = createSvgIcon(<><path d="M3 4H21V7H20L17.5 21H6.5L4 7H3V4M17.97 7H6.03L8.15 19H15.85L17.97 7Z" /></>, 'BucketOutlineIcon');
export default BucketOutlineIcon